<div class="cx-modal-container">
  <div class="cx-modal-content">
    <div class="cx-dialog-header modal-header">
      <div class="dialog-title">
        <h4 class="title">How to Update a Dispenser Agreement</h4>
        <button type="button" class="close" aria-label="Close" (click)="dismissModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
    <div class="cx-dialog-body modal-body">
      <div>
        <p>{{ 'dispenserAgreement.updateExplanation' | cxTranslate }}</p>
        <p><b>For example: </b>{{ 'dispenserAgreement.updateExample' | cxTranslate }}</p>
      </div>
      <div>
        <img src="public/images/update-dispenser-original.png" />
        <br />
        <img src="public/images/update-dispenser.png" />
      </div>
      <div>
        <p>{{ 'dispenserAgreement.statusChangeWarning' | cxTranslate }}</p>
        <br />
        <p class="queries">{{ 'dispenserAgreement.queries' | cxTranslate }}</p>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-sm btn-secondary" (click)="dismissModal()">
        {{ 'shared.backTo.back' | cxTranslate }}
      </button>
      <button class="btn btn-primary btn-sm" (click)="updateDispenserAgreement()">
        {{ 'dispenserAgreement.continueToUpdate' | cxTranslate }}
      </button>
    </div>
  </div>
</div>
